import { RemoteVideo } from 'amazon-chime-sdk-component-library-react'
import { ParticipantBadge } from '@components/atoms/ParticipantBadge/ParticipantBadge'
import { SpeakingIndicator } from '@components/atoms/SpeakingIndicator/SpeakingIndicator'
import { NoRemoteVideoView } from '@components/molecules/NoRemoteVideoView/NoRemoteVideoView'
import { useRemoteParticipantMuteState } from '@hooks/useRemoteParticipantMuteState'

type RemoteVideoContainerProps = {
  hasRemoteParticipants: boolean
  hasRemoteVideo: boolean
  remoteVideoTileId?: number
  isRemoteSpeaking: boolean
  participantName: string
  participantInitials: string
  isDeparted: boolean // Kept for backwards compatibility but not used
}

/**
 * Remote video container component
 * Shows remote participant video or initials when present
 * Departed state logic has been removed for 2-user video conference
 */
export const RemoteVideoContainer = ({
  hasRemoteParticipants,
  hasRemoteVideo,
  remoteVideoTileId,
  isRemoteSpeaking,
  participantName,
  participantInitials
}: RemoteVideoContainerProps) => {
  const isRemoteMuted = useRemoteParticipantMuteState()

  // If no participant, show waiting state
  if (!hasRemoteParticipants) {
    return (
      <div className="flex h-full w-full items-center justify-center">
        <NoRemoteVideoView message="En attente d'autres participants..." />
      </div>
    )
  }

  return (
    <>
      <div className="absolute inset-0 flex items-center justify-center">
        {hasRemoteVideo && remoteVideoTileId !== undefined ? (
          <RemoteVideo tileId={remoteVideoTileId} />
        ) : (
          <SpeakingIndicator isSpeaking={isRemoteSpeaking && !hasRemoteVideo} size="lg">
            <div className="flex h-24 w-24 items-center justify-center rounded-full bg-surface-medium">
              <span className="text-4xl font-bold">{participantInitials}</span>
            </div>
          </SpeakingIndicator>
        )}
      </div>

      <ParticipantBadge name={participantName} position="bottom-left" isMuted={isRemoteMuted} />
    </>
  )
}
